export const MEMBERSHIP_STATUS = {
  NEW: 1, // The user has signup for the membership but didn't yet paid for it.
  ACTIVE: 2, // The user membership is paid for the membership and is in active state.
  EXPIRED: 3,
  SUSPENDED: 4,
  EXITED: 5,
  NOT_FULFILLED: 6,
  ADHOC: -1,
};
